import React from "react";

import { SelectComponent, SelectProps } from "shared/components";
import { ISelectOption } from "./types";

interface Props extends SelectProps {
  loadOptions?: (query: string) => Promise<ISelectOption[]>;
}

export const AsyncSelect: React.FC<Props> = (props) => {
  return <SelectComponent {...props} isAsync />;
};
